// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3JwPj","select":"Header_select__1ple7","clinic":"Header_clinic__3csjO"};